import { render, staticRenderFns } from "./LoadGameForm.vue?vue&type=template&id=06d9a8f0&"
import script from "./LoadGameForm.vue?vue&type=script&lang=ts&"
export * from "./LoadGameForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports